module.exports = __webpack_public_path__ + "img/popup_gyeonggi_school.88792892.png";